import { css } from "styled-components/macro";
import { rem } from "polished";

import { colors, fonts } from "./Styles.variables";

const borderStyle = `${rem("1px")} solid ${colors.gray200}`;
const breakpointStacked = `(min-width: ${rem("1000px")})`;

export const listingDesktopStyles = css`
  padding-bottom: ${rem("27px")};

  &:not(.listing-has-changes) {
    ${({ border }) =>
      border === "bottom"
        ? "border-bottom:" + borderStyle
        : "border-top:" + borderStyle};

    padding-top: ${rem("31px")};
  }

  &.listing-has-changes {
    padding-top: ${rem("9px")};
  }

  .callout + & {
    border-top: none !important;
  }

  .listing-changes {
    margin-bottom: ${rem("27px")};
  }

  .listing-row {
    @media ${breakpointStacked} {
      display: flex;
    }
  }

  .listing-photo {
    margin-bottom: ${rem("25px")};

    @media ${breakpointStacked} {
      margin-bottom: 0;
      margin-right: ${rem("28px")};
      max-width: ${rem("303px")};
      width: ${(303 / 813) * 100}%;
    }

    .listing-photo-container {
      background-color: ${colors.gray200};
      height: 0;
      overflow: hidden;
      padding-top: 57.1428571%;
      position: relative;

      @media ${breakpointStacked} {
        padding-top: 100%;
      }
    }
  }

  .listing-details {
    @media ${breakpointStacked} {
      width: ${((813 - 303 - 28) / 813) * 100}%;
    }
  }

  .listing-categories {
    font-size: ${rem("15px")};
    line-height: 1;
    margin-bottom: ${rem("12px")};
    text-transform: uppercase;

    @media ${breakpointStacked} {
      padding-top: ${rem("4px")};
    }

    .categories-loading,
    .category:not(:last-child) {
      color: ${colors.gray600};
    }

    .category:last-child {
      color: ${colors.black};
      font-weight: ${fonts.weights.bold};
    }
  }

  .listing-title {
    font-size: ${rem("28px")};
    margin-bottom: ${rem("9px")};
  }

  .listing-location {
    font-size: ${rem("22px")};
    margin-bottom: ${rem("20px")};
  }

  .listing-meta {
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    margin: 0;
    padding: 0;

    li:not([class*="listing-meta-break"]) {
      display: block;
      margin-bottom: ${rem("22px")};

      &:not(:last-child) {
        padding-right: ${rem("28px")};
      }
    }

    li[class*="listing-meta-break"] {
      display: none;
      width: 100%;

      &.listing-meta-break-md {
        display: block;

        & + li {
          border-left: 0 none;
          padding-left: 0;
        }
      }
    }

    .label-block {
      font-size: ${rem("14px")};
      color: ${colors.gray600};
    }

    strong {
      font-size: ${rem("20px")};
    }

    small {
      font-size: ${rem("14px")};
      text-transform: uppercase;
    }

    .value-listed {
      color: ${colors.gray600};
      font-size: ${rem("14px")};
      padding-top: ${rem("6px")};
    }

    @media (min-width: ${rem("1279px")}) {
      li:not(:last-child) {
        padding-right: ${rem("46px")};
      }

      .label-block,
      small {
        font-size: ${rem("16px")};
      }

      strong {
        font-size: ${rem("22px")};
      }
    }
  }

  .listing-view {
    margin-bottom: ${rem("25px")};

    &.listing-view-multiple {
      > * {
        display: block;

        &:not(:last-child) {
          margin-bottom: ${rem("10px")};
        }
      }

      @media (min-width: ${rem("1140px")}) {
        display: flex;

        > * {
          width: auto;

          &,
          &:not(:last-child) {
            margin-bottom: 0;
          }

          &:not(:first-child) {
            margin-left: ${rem("16px")};
          }
        }
      }
    }
  }

  .listing-actions {
    font-size: ${"15px"};
    justify-content: center;

    @media (min-width: ${rem("1140px")}) {
      justify-content: flex-start;
    }

    > * {
      margin-bottom: ${rem("4px")};
    }

    > :not(:last-child) {
      margin-right: ${rem("24px")};
    }
  }
`;
